// src/unAuth/components/HowItWorks.js
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLink,
  faRobot,
  faList,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import "./HowItWorks.css";

const steps = [
  {
    icon: faLink,
    title: "Paste your YouTube URL",
    text: "Copy any YouTube video link and paste it into the input field. We support standard watch links, shorts, and live stream replays.",
  },
  {
    icon: faRobot,
    title: "AI generates chapters",
    text: "Our AI analyzes the video's captions and audio to identify topics, segments, and key moments. Timestamps are created automatically in seconds.",
  },
  {
    icon: faList,
    title: "Review your timestamps",
    text: "See a clear list of chapters with exact times. Each timestamp links directly to that moment in the video when clicked.",
  },
  {
    icon: faCopy,
    title: "Copy and share",
    text: "Copy the full timestamp list to paste in your video description, comments, or blog. Help viewers jump to the parts they care about.",
  },
];

export default function HowItWorks() {
  return (
    <section className="how-it-works" id="how-it-works" data-animate="fade-up">
      <h2 className="how-it-works-title">How it works</h2>
      <p className="how-it-works-intro">
        Timestampgn uses AI to turn any YouTube video into structured chapters.
        We combine YouTube&apos;s data with our own formatting, interface, and
        guides—so you get a ready-to-use result, not raw API output. No manual
        editing: paste, generate, and share.
      </p>
      <div className="how-it-works-grid reveal-stagger">
        {steps.map((step, i) => (
          <div key={i} className="how-it-works-step">
            <div className="how-it-works-icon">
              <FontAwesomeIcon icon={step.icon} />
            </div>
            <h3 className="how-it-works-step-title">{step.title}</h3>
            <p className="how-it-works-step-text">{step.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
